export const LOADING_INDICATOR = 'LOADING_INDICATOR';
export const TOAST_SUCCESS = 'TOAST_SUCCESS';
export const TOAST_ERROR = 'TOAST_ERROR';
export const UPDATE_DISPLAYNAME_AND_AVATAR = 'UPDATE_DISPLAYNAME_AND_AVATAR';
export const PUBLISH_PROJECT_INFORMATION = 'PUBLISH_PROJECT_INFORMATION';
export const SYNC_USER_PROFILE = 'SYNC_USER_PROFILE';



// WEBPACK FOOTER //
// ./src/constants/pubus-action-type.js